import { Logger } from 'student/secure/checkout/sentry'

const blacklistedActions = new Set(['REGISTER_HTML_ELEMENTS'])

export const sentryMiddleware = store => next => action => {
  const actionType: string = action.type
  if (!blacklistedActions.has(actionType)) {
    Logger.addBreadcrumb(actionType, { category: 'spc:actions' })
  }
  try {
    return next(action)
  } catch (err) {
    Logger.error(err)
    throw err
  }
}
